import { Component, AfterViewInit, DoCheck, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { FormControl, FormBuilder, Validators } from '@angular/forms';
import { OwnerCarrierService } from '../../../service/owner-carrier/owner-carrier.service';
import { TypePrintDeliService } from '../../../service/type-print-deli/type-print-deli.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9233',
  templateUrl: 'wa9233.component.html',
  styleUrls: ['wa9233.component.scss']
})

export class Wa9233Component implements AfterViewInit, DoCheck, OnChanges {
  public componentTitle = 'WA9233:荷主別配送会社マスタ修正';

  @Output() onSubmitClick = new EventEmitter();
  public working = false;
  public working2 = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // 固有入力対象配送会社コード
  public custCdInputForCarrierCd = null;

  // fixed value
  public ownerId: number;
  public ownerCd: string;
  public ownerTx: string;
  public carrierCd: string;
  public carrierTx: string;

  // drop down list
  public typeprintdelis: any

  // for error message
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public typeprintdeliCd = new FormControl('', [
    Validators.required,
  ]);
  public yamatocusthCd = new FormControl('', [
    Validators.pattern(validation.yamatocusthCd.pattern),
  ]);
  public yamatocustdCd = new FormControl('', [
    Validators.pattern(validation.yamatocustdCd.pattern),
  ]);
  public sagawacusthCd = new FormControl('', [
    Validators.pattern(validation.sagawacusthCd.pattern),
  ]);
  public sagawacustdCd = new FormControl('', [
    Validators.pattern(validation.sagawacustdCd.pattern),
  ]);
  public sagawacustcheckCd = new FormControl('', [
    Validators.pattern(validation.sagawacustcheckCd.pattern),
  ]);
  public jpcustCd = new FormControl('', [
    Validators.pattern(validation.jpcustCd.pattern),
  ]);
  public seinocustCd = new FormControl('', [
    Validators.pattern(validation.seinocustCd.pattern),
  ]);
  public fukuyamacusthCd = new FormControl('', [
    Validators.pattern(validation.fukuyamacusthCd.pattern),
  ]);
  public fukuyamacustdCd = new FormControl('', [
    Validators.pattern(validation.fukuyamacustdCd.pattern),
  ]);
  // build FormGroup
  myForm = this.builder.group({
    typeprintdeliCd: this.typeprintdeliCd,
    yamatocusthCd: this.yamatocusthCd,
    yamatocustdCd: this.yamatocustdCd,
    sagawacusthCd: this.sagawacusthCd,
    sagawacustdCd: this.sagawacustdCd,
    sagawacustcheckCd: this.sagawacustcheckCd,
    jpcustCd: this.jpcustCd,
    seinocustCd: this.seinocustCd,
    fukuyamacusthCd: this.fukuyamacusthCd,
    fukuyamacustdCd: this.fukuyamacustdCd,
  });
  public onChangeTypePrintDeliCls = false;
  public yamatocusthCdCls = false;
  public yamatocustdCdCls = false;
  public sagawacusthCdCls = false;
  public sagawacustdCdCls = false;
  public sagawacustcheckCdCls = false;
  public jpcustCdCls = false;
  public seinocustCdCls = false;
  public fukuyamacusthCdCls = false;
  public fukuyamacustdCdCls = false;
  public recShipcaseFl = 0;


  private errorInfo = '';
  @Input() rowData: object;
  private openwindow: boolean = false;
  private isDelayHide = true;

  constructor(
    private builder: FormBuilder,
    private ownerCarrierService: OwnerCarrierService,
    private typePrintDeliService: TypePrintDeliService,
    private commonService: CommonService,
  ) {
    sessionStorage.removeItem('wa9233openotherwindow');
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    // drop down list
    this.typePrintDeliService
      .get()
      .then(___outputJson => {
        console.log(___outputJson);
        this.typeprintdelis = ___outputJson.typeprintdelis;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });

  }

  onChangeTypePrintDeli(event) {
    this.errorInfo = '';

    this.checkNeedCustCd();
    if (event.target.value !== this.rowData['carrierCd']) {
      this.onChangeTypePrintDeliCls = true;
      this.working = true;
    }
    else {
      this.working = false;
    }

  }

  checkNeedCustCd() {
    if (this.typeprintdeliCd.value === '40') {
      this.custCdInputForCarrierCd = this.carrierCd;
    } else {
      this.custCdInputForCarrierCd = null;
    }
  }

  onSubmit() {
    var attrMap = {};
    if (this.custCdInputForCarrierCd === '1001') {
      if (!this.yamatocusthCd.value) {
        this.errorInfo = 'ヤマトのサーマル伝票を選択した場合は、（運賃請求先コード12桁）を入力してください';
        return;
      }
      var yamatocusthCd = this.yamatocusthCd.value ? this.yamatocusthCd.value.trim() : '';
      var yamatocustdCd = this.yamatocustdCd.value ? this.yamatocustdCd.value.trim() : '';

      if (!yamatocusthCd) {
        yamatocusthCd = ''
      }
      if (!yamatocustdCd) {
        yamatocustdCd = ''
      }

      attrMap = {
        'YAMATOCUSTH_CD': yamatocusthCd,
        'YAMATOCUSTD_CD': yamatocustdCd
      }
    }
    else if (this.custCdInputForCarrierCd === '1002') {
      if (!this.sagawacusthCd.value || !this.sagawacustdCd.value || !this.sagawacustcheckCd.value) {
        this.errorInfo = '佐川のサーマル伝票を選択した場合は、顧客コード（親番8桁・枝番3桁・チェックデジット1桁）を入力してください';
        return;
      }
      attrMap = {
        'SAGAWACUSTH_CD': this.sagawacusthCd.value,
        'SAGAWACUSTD_CD': this.sagawacustdCd.value,
        'SAGAWACUSTCHECK_CD': this.sagawacustcheckCd.value
      }
    }
    else if (this.custCdInputForCarrierCd === '1003') {
      if (!this.jpcustCd.value) {
        this.errorInfo = 'JPのサーマル伝票を選択した場合は、（ゆうびんビズカードお客さま番号32桁）を入力してください';
        return;
      }

      attrMap = {
        'JPCUST_CD': this.jpcustCd.value
      }
    }
    else if (this.custCdInputForCarrierCd === '1004') {
      if (!this.seinocustCd.value) {
        this.errorInfo = '西濃のサーマル伝票を選択した場合は、（西濃・運賃契約荷主コード11桁）を入力してください';
        return;
      }

      attrMap = {
        'SEINOCUST_CD': this.seinocustCd.value
      }
    }
    else if (this.custCdInputForCarrierCd === '1006') {
      var fukuyamacusthCd = this.fukuyamacusthCd.value.trim();
      var fukuyamacustdCd = this.fukuyamacustdCd.value.trim();
      if (!this.fukuyamacusthCd.value || !this.fukuyamacustdCd.value) {
        this.errorInfo = '福山通運のサーマル伝票を選択した場合は、（荷主コード10桁・部課所コード枝番6桁）を入力してください';
        return;
      }

      attrMap = {
        'FUKUYAMACUSTH_CD': fukuyamacusthCd,
        'FUKUYAMACUSTD_CD': fukuyamacustdCd
      }
    }

    if (this.carrierCd === '1001') {
      attrMap['YAMATO_RECSHIPCASE'] = this.recShipcaseFl;
    }
    else if (this.carrierCd === '1002') {
      attrMap['SAGAWA_RECSHIPCASE'] = this.recShipcaseFl;
    }
    else if (this.carrierCd === '1003') {
      attrMap['JP_RECSHIPCASE'] = this.recShipcaseFl;
    }
    else if (this.carrierCd === '1004') {
      attrMap['SEINO_RECSHIPCASE'] = this.recShipcaseFl;
    }
    else if (this.carrierCd === '1006') {
      attrMap['FUKUYAMA_RECSHIPCASE'] = this.recShipcaseFl;
    }

    //SW-2097　ダブルクリック抑止
    if (this.working2) return;
    this.working2 = true;
    this.ownerCarrierService
      .put(
        this.ownerId,
        this.carrierCd,
        this.typeprintdeliCd.value,
        attrMap,
        'wa9233'
      )
      .then(outputJson => {
        //sessionStorage.setItem('SuccessInfoMessage', '完了,修正が完了しました');
        sessionStorage.setItem('wa9233upd', 'ok');
        this.onSubmitClick.emit();
        this.cancel();
        this.errorInfo = '';
        this.working2 = false;
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.working2 = false;
      });
  }

  ngDoCheck() {
    if (sessionStorage.getItem('wa9233openotherwindow') === 'open') {
      this.openwindow = true;
      this.isDelayHide = false;
    }

  }

  ngOnChanges() {
    if (this.rowData) {
      const rowOwnerCarrier: object = this.rowData;
      this.ownerId = rowOwnerCarrier['ownerId'];
      this.ownerCd = rowOwnerCarrier['ownerCd'];
      this.ownerTx = rowOwnerCarrier['ownerTx'];
      this.carrierCd = rowOwnerCarrier['carrierCd'];
      this.carrierTx = rowOwnerCarrier['carrierTx'];
      this.typeprintdeliCd.setValue(rowOwnerCarrier['typeprintdeliCd']);

      this.yamatocusthCd.setValue(rowOwnerCarrier['attrMap']['YAMATOCUSTH_CD']);
      this.yamatocustdCd.setValue(rowOwnerCarrier['attrMap']['YAMATOCUSTD_CD']);
      this.sagawacusthCd.setValue(rowOwnerCarrier['attrMap']['SAGAWACUSTH_CD']);
      this.sagawacustdCd.setValue(rowOwnerCarrier['attrMap']['SAGAWACUSTD_CD']);
      this.sagawacustcheckCd.setValue(rowOwnerCarrier['attrMap']['SAGAWACUSTCHECK_CD']);
      this.jpcustCd.setValue(rowOwnerCarrier['attrMap']['JPCUST_CD']);
      this.seinocustCd.setValue(rowOwnerCarrier['attrMap']['SEINOCUST_CD']);
      this.fukuyamacusthCd.setValue(rowOwnerCarrier['attrMap']['FUKUYAMACUSTH_CD']);
      this.fukuyamacustdCd.setValue(rowOwnerCarrier['attrMap']['FUKUYAMACUSTD_CD']);
      this.checkNeedCustCd();

      if (this.carrierCd === '1001') {
        this.recShipcaseFl = parseInt(rowOwnerCarrier['attrMap']['YAMATO_RECSHIPCASE']);
      }
      else if (this.carrierCd === '1002') {
        this.recShipcaseFl = parseInt(rowOwnerCarrier['attrMap']['SAGAWA_RECSHIPCASE']);
      }
      else if (this.carrierCd === '1003') {
        this.recShipcaseFl = parseInt(rowOwnerCarrier['attrMap']['JP_RECSHIPCASE']);
      }
      else if (this.carrierCd === '1004') {
        this.recShipcaseFl = parseInt(rowOwnerCarrier['attrMap']['SEINO_RECSHIPCASE']);
      }
      else if (this.carrierCd === '1006') {
        this.recShipcaseFl = parseInt(rowOwnerCarrier['attrMap']['FUKUYAMA_RECSHIPCASE']);
      }

      if(!this.recShipcaseFl){
        this.recShipcaseFl = 0;
      }
      
    }
  }

  cancel() {
    sessionStorage.removeItem('wa9233openotherwindow');
    this.working = false;
    this.errorInfo = '';

    this.openwindow = false;
    setTimeout(() => {
      this.isDelayHide = true;
    }, 300);
  }

  change(event) {
    this.errorInfo = '';

    console.log(this.rowData['attrMap']['YAMATOCUSTD_CD'])
    if (!this.yamatocusthCd.errors
      && !this.yamatocustdCd.errors
      && !this.sagawacusthCd.errors
      && !this.sagawacustdCd.errors
      && !this.sagawacustcheckCd.errors
      && !this.jpcustCd.errors
      && !this.seinocustCd.errors
      && !this.fukuyamacusthCd.errors
      && !this.fukuyamacustdCd.errors
    ) {
      if (event.target.value !== this.rowData['attrMap']['YAMATOCUSTH_CD']
        || event.target.value !== this.rowData['attrMap']['YAMATOCUSTD_CD']
        || event.target.value !== this.rowData['attrMap']['SAGAWACUSTH_CD']
        || event.target.value !== this.rowData['attrMap']['SAGAWACUSTD_CD']
        || event.target.value !== this.rowData['attrMap']['SAGAWACUSTCHECK_CD']
        || event.target.value !== this.rowData['attrMap']['JPCUST_CD']
        || event.target.value !== this.rowData['attrMap']['SEINOCUST_CD']
        || event.target.value !== this.rowData['attrMap']['FUKUYAMACUSTH_CD']
        || event.target.value !== this.rowData['attrMap']['FUKUYAMACUSTD_CD']
      ) {
        this.working = true;
      } else {
        this.working = false;
      }
      if (event.target.value !== this.rowData['attrMap']['YAMATOCUSTH_CD']) this.yamatocusthCdCls = true;
      if (event.target.value !== this.rowData['attrMap']['YAMATOCUSTD_CD']) this.yamatocustdCdCls = true;
      if (event.target.value !== this.rowData['attrMap']['SAGAWACUSTH_CD']) this.sagawacusthCdCls = true;
      if (event.target.value !== this.rowData['attrMap']['SAGAWACUSTD_CD']) this.sagawacustdCdCls = true;
      if (event.target.value !== this.rowData['attrMap']['SAGAWACUSTCHECK_CD']) this.sagawacustcheckCdCls = true;
      if (event.target.value !== this.rowData['attrMap']['JPCUST_CD']) this.jpcustCdCls = true;
      if (event.target.value !== this.rowData['attrMap']['SEINOCUST_CD']) this.seinocustCdCls = true;
      if (event.target.value !== this.rowData['attrMap']['FUKUYAMACUSTH_CD']) this.fukuyamacusthCdCls = true;
      if (event.target.value !== this.rowData['attrMap']['FUKUYAMACUSTD_CD']) this.fukuyamacustdCdCls = true;

    } else {
      this.working = false;
    }

    if (event.target.value === '') {
      this.working = this.working && (event.target.id === '_yamatocusthCd' || event.target.id === '_yamatocustdCd')
    }

  }

  changeRecShipcaseFl(){
    if (this.recShipcaseFl !== this.rowData['attrMap']['YAMATO_RECSHIPCASE']
      || this.recShipcaseFl !== this.rowData['attrMap']['SAGAWA_RECSHIPCASE']
      || this.recShipcaseFl !== this.rowData['attrMap']['JP_RECSHIPCASE']
      || this.recShipcaseFl !== this.rowData['attrMap']['SEINO_RECSHIPCASE']
      || this.recShipcaseFl !== this.rowData['attrMap']['FUKUYAMA_RECSHIPCASE']
    ) {
      this.working = true;
    } else {
      this.working = false;
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9233/wa9233.component.ts